import { GraphQLClient } from 'graphql-request';

/**
 * Get GraphQL Client
 * @category Utility Function
 * @summary Generates a GraphQL client with options.
 * @arg {String} bodyHash - A stringified object for the request.
 * @arg {String} mode - defines mode.
 * @arg {Boolean} useOldApi - If "true", will use the old API endpoint
 * @arg {Boolean} useInternalHost - If "true", will use the internal AWS hostname
 * @return {GraphQLClient} A GraphQLClient object
 */
export default function GetGraphQLClient(bodyHash, mode, useOldApi = false, useInternalHost = false) {
  const authName = process.env.NEXT_PUBLIC_AUTH_USERNAME ?? null;
  const authPass = process.env.NEXT_PUBLIC_AUTH_PASSWORD ?? null;
  const authString = authName && authPass ? `${authName}:${authPass}` : null;
  const drupalBasicAuth = authString
      ? Buffer.from(authString, 'utf8').toString('base64')
      : null;
  const hostname = (useInternalHost && process.env.NEXT_INTERNAL_HOST) ? process.env.NEXT_INTERNAL_HOST : process.env.NEXT_PUBLIC_API_DOMAIN ?? process.env.NEXT_PUBLIC_BASE_URL;

  const endpoint = useOldApi
      ? hostname && process.env.NEXT_PUBLIC_NEW_API_ENDPOINT
          ? `${hostname}${process.env.NEXT_PUBLIC_NEW_API_ENDPOINT}`
          : 'https://www.thedrewbarrymoreshow.com/api/query'
      : hostname
          ? `${hostname}${process.env.NEXT_PUBLIC_NEW_API_ENDPOINT}`
          : 'https://www.thedrewbarrymoreshow.com/cmv_graphql/api/query';

  const options = {
    method: 'POST', // Ensure the request is always a POST
    headers: {
      'Content-Type': 'application/json, text/html',
      'Accept': 'application/json, text/plain, text/html',
      'body-hash': bodyHash
    },
  };

  if (drupalBasicAuth && options) {
    options.headers.authorization = `Basic ${drupalBasicAuth}`;
  }

  if (mode) {
    options.mode = mode;
  }

  if (process.env.NEXT_PUBLIC_LOG_ENDPOINTS === 'true') {
    console.log('[ENDPOINT]', useInternalHost ? 'internal_call' : 'external_call', mode, bodyHash);
  }

  return new GraphQLClient(endpoint, options);
}